export default __webpack_public_path__ + "static/care01-b32e01edd3f089018282ccd728c24aaa.png";